export default ({ $axios }) => ({
  getPendentTeamAllowances: async () => {
    try {
      const { data } = await $axios.get('/v3/app/allowance/team/pendent')
      return data
    } catch (error) {
      console.error('Error fetching pendent team allowances', error)
      throw error
    }
  },
  allowancesBulkSetStatus: async (ids, status) => {
    try {
      await $axios.post(`/v3/app/allowance/bulk-set-status/${status}`, {
        allowanceIds: ids,
      })
    } catch (error) {
      console.error('Error setting allowances status', error)
      throw error
    }
  },

  getPendentTeamRetroactiveAllowances: async () => {
    try {
      const { data } = await $axios.get(
        '/v3/app/retroactiveallowance/team/pendent'
      )
      return data
    } catch (error) {
      console.error('Error fetching pendent team retroactive allowances', error)
      throw error
    }
  },
  retroactiveAllowancesBulkSetStatus: async (ids, status) => {
    try {
      await $axios.post(
        `/v3/app/retroactiveallowance/bulk-set-status/${status}`,
        {
          allowanceIds: ids,
        }
      )
    } catch (error) {
      console.error('Error setting retroactive allowances status', error)
      throw error
    }
  },

  getPendentTeamTransfers: async () => {
    try {
      const { data } = await $axios.get('/v3/app/transfer/team/pendent')
      return data
    } catch (error) {
      console.error('Error fetching pendent team transfers', error)
      throw error
    }
  },
  transfersBulkSetStatus: async (ids, status) => {
    try {
      await $axios.post(`/v3/app/transfer/status/${status}`, {
        ids: ids,
      })
    } catch (error) {
      console.error('Error setting transfers status', error)
      throw error
    }
  },

  getPendentTeamFoodSolutions: async () => {
    try {
      const { data } = await $axios.get('/v3/app/foodsolution/team/pendent')
      return data
    } catch (error) {
      console.error('Error fetching pendent team food solutions', error)
      throw error
    }
  },
  foodSolutionsBulkSetStatus: async (ids, status) => {
    try {
      await $axios.post(`/v3/app/foodsolution/bulk-set-status/${status}`, {
        ids: ids,
      })
    } catch (error) {
      console.error('Error setting food solutions status', error)
      throw error
    }
  },

  getPendentTeamMileageAllowances: async () => {
    try {
      const { data } = await $axios.get('/v3/app/mileageallowance/team/pendent')
      return data
    } catch (error) {
      console.error('Error fetching pendent team mileage allowances', error)
      throw error
    }
  },
  mileageAllowancesBulkSetStatus: async (ids, status) => {
    try {
      await $axios.post(`/v3/app/mileageallowance/bulk-set-status/${status}`, {
        ids: ids,
      })
    } catch (error) {
      console.error('Error setting mileage allowances status', error)
      throw error
    }
  },
})
